import Vue from 'vue';
import vueConfig from 'vue-config';

const config = {
  app_api: {
    host: process.env.EGW_API_HOST,
    prefix: 'api/v1/',
    endpoints: {
      file_upload: 'file-upload',
    },
  },
  egw_dev: process.env.EGW_DEV,
  recaptchaStorageKey: process.env.RECAPTCHA_KEY,
  tokenStorage: {
    name: 'tokenStorage',
  },
  userStorage: {
    name: 'userStorage',
  },
  mainMenu: 'egw_main',
};

Vue.use(vueConfig, config);

export default config;



// WEBPACK FOOTER //
// ./src/config.js